// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
  news: '/news',
  apps: '/apps',
  forcompanies: '/for-companies',
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    general: {
      app: path(ROOTS_DASHBOARD, '/app'),
      users: path(ROOTS_DASHBOARD, '/users'),
      analytics: path(ROOTS_DASHBOARD, '/analytics'),
      vacancies: path(ROOTS_DASHBOARD, '/vacancies'),
      messages: path(ROOTS_DASHBOARD, '/messages'),
      video_template: path(ROOTS_DASHBOARD, '/video-template')
    },
    vacancies: {
      root: path(ROOTS_DASHBOARD, '/vacancies'),
      new: path(ROOTS_DASHBOARD, '/vacancies/new')
    },
    video_template: {
      root: path(ROOTS_DASHBOARD, '/video-template'),
      new: path(ROOTS_DASHBOARD, '/video-template/new')
    },
    messages: {
      root: path(ROOTS_DASHBOARD, '/messages'),
      new: path(ROOTS_DASHBOARD, '/messages/new')
    },
    mail: {
      root: path(ROOTS_DASHBOARD, '/mail'),
      all: path(ROOTS_DASHBOARD, '/mail/all')
    },
    user: {
      root: path(ROOTS_DASHBOARD, '/user'),
      videocv: path(ROOTS_DASHBOARD, '/user/profile/video-cv'),
      messages: path(ROOTS_DASHBOARD, '/notification'),
      profile: path(ROOTS_DASHBOARD, '/user/profile'),
      cards: path(ROOTS_DASHBOARD, '/user/cards'),
      list: path(ROOTS_DASHBOARD, '/user/list'),
      newUser: path(ROOTS_DASHBOARD, '/user/new'),
      editById: path(ROOTS_DASHBOARD, '/user/ada-lindgren/edit'),
      account: path(ROOTS_DASHBOARD, '/user/account')
    },
    users: {
      root: path(ROOTS_DASHBOARD, '/users'),
    },
    chat: {
      root: path(ROOTS_DASHBOARD, '/chat'),
      new: path(ROOTS_DASHBOARD, '/chat/new'),
      conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
    },
    calendar: path(ROOTS_DASHBOARD, '/calendar'),
    kanban: path(ROOTS_DASHBOARD, '/kanban'),
    eCommerce: {
      root: path(ROOTS_DASHBOARD, '/e-commerce'),
      shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
      product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
      productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
      list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
      newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
      editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
      checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
      invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
    },
    blog: {
      root: path(ROOTS_DASHBOARD, '/blog'),
      posts: path(ROOTS_DASHBOARD, '/blog/posts'),
      post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
      postById: path(ROOTS_DASHBOARD, '/blog/post/portfolio-review-is-this-portfolio-too-creative'),
      newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
    }
};